import { scrollToElementWithStickyOffset } from "../../../common/js/helpers"

export default () => ({
  init() {
    this.store = Alpine.store("data")
  },

  handleDiscountButtonClick(anchorId = "discountExpiresAnchor") {
    this.store.internalTracker.trackClick({ clickName: "Anchor 1 Clicked" })
    document.getElementById(anchorId).scrollIntoView({ behavior: "smooth" })
  },

  handleDiscountClickWithScrollOffset() {
    this.store.internalTracker.trackClick({ clickName: "Anchor 1 Clicked" })
    scrollToElementWithStickyOffset({ targetSelector: "#offer-container", stickySelector: "#sticky-top-banner", offset: 12 })
  },
})
